if (!customElements.get('masonry-grid')) {
  customElements.define('masonry-grid', class MasonryGrid extends HTMLElement {
    constructor() {
      super();
      this.config = { columns: 4, gap: 10, gapMobile: 10, responsive: [] };
      this._resizeTimer = null;
      this._isResizing = false;
      this.isRTL = document.documentElement.dir === 'rtl';
      this._onResize = () => {
        if (!this._isResizing) {
          this._isResizing = true;
          this.classList.add('is-resizing');
        }
                
        clearTimeout(this._resizeTimer);
        this._resizeTimer = setTimeout(() => {
          this.layout();
          this._isResizing = false;
          this.classList.remove('is-resizing');
        }, 100);
      };
    }

    connectedCallback() {
      const jsonData = this.getAttribute('data-masonry');
            
      if (jsonData) {
        try {
          this.config = Object.assign(this.config, JSON.parse(jsonData));
        } catch (e) {
          console.error('MasonryGrid: Invalid JSON configuration', e);
        }
      }

      this.listContainer = this.querySelector('ul');
      if (!this.listContainer) return;
      this.gridItems = Array.from(this.listContainer.querySelectorAll('li'));

      this.layout();

      requestAnimationFrame(() => {
        this.classList.add('is-initialized');
      });

      window.addEventListener('resize', this._onResize);
      this.mutationObserver = new MutationObserver(() => {
        const oldRTL = this.isRTL;
        this.isRTL = document.documentElement.dir === 'rtl';
        if (oldRTL !== this.isRTL) {
          this.layout();
        }
      });
      this.mutationObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['dir'] });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this._onResize);
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }

    layout() {
      const containerWidth = this.offsetWidth;
            
      if (containerWidth === 0) return;

      let targetColumns = this.config.columns;

      if (this.config.responsive && this.config.responsive.length) {
        const sortedRules = [...this.config.responsive].sort((a, b) => a[0] - b[0]);
                
        for (const [breakpoint, columnCount] of sortedRules) {
          if (containerWidth <= breakpoint) {
            targetColumns = columnCount;
            break;
          }
        }
      }

      const gap = containerWidth < 577 ? this.config.gapMobile : this.config.gap;
      const itemWidth = Math.floor((containerWidth - (gap * (targetColumns - 1))) / targetColumns);
      const columnHeights = Array(targetColumns).fill(0);

      this.gridItems.forEach(item => {
        item.style.width = itemWidth + 'px';

        const minColumnHeight = Math.min(...columnHeights);
        const columnIndex = columnHeights.indexOf(minColumnHeight);

        let posX;
        if (this.isRTL) {
          posX = containerWidth - (columnIndex * (itemWidth + gap)) - itemWidth;
        } else {
          posX = columnIndex * (itemWidth + gap);
        }
        const posY = minColumnHeight;

        item.style.transform = `translate(${posX}px, ${posY}px)`;
        columnHeights[columnIndex] += item.offsetHeight + gap;
      });

      this.listContainer.style.height = (Math.max(...columnHeights) - gap) + 'px';
    }
  });
}